import { environment } from '@environments/environment';

export const SUPPORT_URLS = {
  CALENSO_SUPPORT_FRESHDESK_URL: 'https://support.calenso.com/',
  CALENSO_SUPPORT_FRESHDESK_TICKET_URL: 'https://support.calenso.com/{lang}/create-ticket',
  API_KEYS: 'https://support.calenso.com/{lang}/api-access',
  CONFERENCE_ARTICLE: 'https://support.calenso.com/{lang}/conference-appointments',
  EXTERNAL_CALENDAR_DYNAMIC_AVAILABILITIES: 'https://support.calenso.com/{lang}/external-calendars',
  DISABLE_DUPLICATE_MINUTE_BLOCKS_IN_WIDGET: 'https://support.calenso.com/{lang}/booking-widget',
  SPF_ENTRY_URL: 'https://support.calenso.com/{lang}/integration-smtp',
  EMERGENCY_SUPPORT_TEL: '+41 41 280 01 68',
  EMERGENCY_SUPPORT_EMAIL: 'urgent-support@calenso.com',
  CALENSO_SUPPORT_ARTICAL: 'https://support.calenso.com/',
  EMAIL_PROVIDER_ARTICLE: 'https://support.calenso.com/{lang}/integration-smtp',
  DATA_PRIVACY_ARTICLE: 'https://support.calenso.com/{lang}/security',
  BOOKING_LINK_ARTICLE: 'https://support.calenso.com/{lang}/booking-link-generator',
  APPOINTMENT_STATUS_ARTICLE: 'https://support.calenso.com/{lang}/appointments',
  CUSTOM_CSS_ARTICLE: 'https://support.calenso.com/{lang}/booking-widget',
  CAPTCHA_ARTICLE: 'https://support.calenso.com/{lang}/security',
  EXTERNAL_LANDING_PAGE_ARTICLE: 'https://support.calenso.com/{lang}/booking-widget',
  CALENDLY_ARTICLE: 'https://support.calenso.com/{lang}/migration-calendly',
  NOTIFICATION_ARTICLE: 'https://support.calenso.com/{lang}/notifications',
  WHITELISTED_IP_ARTICLE: 'https://support.calenso.com/{lang}/ip-addresses',
  WEBHOOK_ARTICLE: 'https://support.calenso.com/{lang}/webhooks',
  INXMAIL_ARTICLE: 'https://support.calenso.com/{lang}/integration-inxmail',
  SENDGRID_ARTICLE: 'https://support.calenso.com/{lang}/integration-sendgrid',
  BOOKING_INTERVAL_ARTICLE: 'https://support.calenso.com/{lang}/services',
  MFA_ARTICLE: 'https://support.calenso.com/{lang}/security#zwei-faktor-authentifizierung-2fa',
  REVIEW_LINK: 'https://reviews.capterra.com/products/new/8974f835-74a2-449c-b066-be70ac63dc5d?lang=',
  SUPPORT_URL: 'https://support.calenso.com',
  TELEPHONE_APPOINTMENT_URL: 'https://calenso.com/support-termin',
  HELP_CENTER: 'https://support.calenso.com',
  CONTACT_SUPPORT: 'https://support.calenso.com/{lang}/create-ticket',
  SUPPORT_TEL: 'tel:+41412800168',
  FAQ: 'https://my.calenso.com/events/details/calenso-meeting/6658',
  HELP_PAGE_URL: 'https://support.calenso.com/',
  CONTACT_US_EMAIL: 'mailto:support@calenso.com',
  EXCEPTIONAL_AVAILABILITIES: 'https://support.calenso.com/{lang}/availabilities',
  PAST_INVOICES: 'https://support.calenso.com/',
  SMS_SETTINGS: 'https://support.calenso.com/{lang}/integration-sms-api',
  CALDAV_SUPPORT_ARTICLE: 'https://support.calenso.com/{lang}/integration-caldav',
  STORE_BRANDING_HELPLINK: 'https://support.calenso.com/{lang}/branches',
  SHORTCUT: 'https://support.calenso.com/',
  // Brand-resolved: the JRNI help centre serves the identical article set and the
  // same /:lang/feature-requests route, so this must not hardcode the Calenso host.
  FEATURE_PROPOSAL_URL: `${environment.brandUrls.BRAND_SUPPORT_URL}/{lang}/feature-requests`,
  TECHNICAL_DOCUMENTATION_URL: 'https://docs.calenso.com/',
  VERSION_URL: 'https://support.calenso.com/{lang}/category/release-notes',
  RESELLER_PAGE_LINK: 'https://calenso.com/affiliate-registration?partnership=',
  FRESHDESK_LINK: 'https://support.calenso.com/',
  FRESHDESK_TICKET_CREATE: 'https://support.calenso.com/{lang}/create-ticket',
  STATUS_PAGE_URL: 'https://status.calenso.com/?utm_source=calenso.com',
  BOOKING_APPOINTMENT_URL: 'https://book.calenso.com/calenso-meeting',
  // The marketing site publishes the contact page under asymmetric paths per language,
  // so this one cannot go through the {lang} placeholder.
  CONTACT_US_PAGE_DE: 'https://calenso.com/kontakt',
  CONTACT_US_PAGE_EN: 'https://calenso.com/en/contact',
  ONLINE_PAYMENT_INFO_URL: 'https://www.calenso.com/online-bezahlung/',
  RESELLER_READ_MORE_URL: 'https://calenso.com/partner',
  SIGNUP_URL: 'https://signup.calenso.com/',
  PHISHING_PREVENTION: 'https://support.calenso.com/{lang}/security',
  APPOINTMENT_RESERVATION: 'https://support.calenso.com/{lang}/appointments',
  WORDPRESS_INTEGRATION: 'https://support.calenso.com/{lang}/iframe-widget-integration',
  JIMDO_INTEGRATION: 'https://support.calenso.com/{lang}/iframe-widget-integration',
  WIX_INTEGRATION: 'https://support.calenso.com/{lang}/iframe-widget-integration',
  GOOGLE_MY_BUSINESS_INTEGRATION: 'https://support.calenso.com/',
  FACEBOOK_INTEGRATION: 'https://support.calenso.com/',
  INSTAGRAM_INTEGRATION: 'https://support.calenso.com/',
  HUBSPOT_INTEGRATION: 'https://support.calenso.com/{lang}/integration-hubspot',
};

export const SUPPORT_VIDEO_URLS = {
  GROUP_APPOINTMENT: 'https://www.loom.com/share/3b90f2499f814a94931f70ddb50dba51',
  STORE: 'https://www.loom.com/share/a07e2d9e955b46e3a6f64546aa174011',
  RESOURCES: 'https://www.loom.com/share/b9a34155bc58429fa1385b74e4ea1c65',
  MFA: 'https://www.loom.com/share/7f49483d340b4f5997f4c436f9b8a7f7',
  MEETING: 'https://www.youtube.com/watch?v=H91FCAeb89I',
  WEBHOOOK: 'https://www.youtube.com/watch?v=-lgv9XLmHE4',
  SMART_ACTION_EMAIL_BEFORE_APPOINTMENT: 'https://www.youtube.com/watch?v=ktQ2ArQKvWc',
  BOOKING_QUESTIONS: 'https://www.youtube.com/watch?v=6xrFOb67jzs&t=12s',
  EXTERNAL_CALENDAR: 'https://www.youtube.com/watch?v=so6ELsScCfI',
  SMART_ACTION_AUTOMATIC_THANKYOU: 'https://www.youtube.com/watch?v=DZaENnHP2wE',
  SMART_ACTION_SATISFACTION_SURVEY: 'https://www.youtube.com/watch?v=__Ren7ytKWA',
  SMART_ACTION_GLOBAL_CANCELLATION: 'https://www.youtube.com/watch?v=mmZ-OQVW7r0',
  TEMPLATES: 'https://www.youtube.com/watch?v=ZhMFjB3FlW8',
  STRIPE: 'https://www.youtube.com/watch?v=FKknTBv1QWw',
  ONBOARDING_DE: 'https://www.loom.com/embed/222c1649d4f94c049a815e8f0bd29944',
  ONBOARDING_EN: 'https://www.loom.com/embed/9f89a636dc924af19e97bbcc5bd495c8'
};
